import React from 'react';
import './AboutUsKurumsalKimlik.css';

const AboutUsKurumsalKimlik = () => {
  return (
    <section className="kurumsal-kimlik-section">
      <div className="kurumsal-kimlik-content">
        <h1 className="kurumsal-kimlik-title">Kurumsal Kimlik</h1>
        <p className="kurumsal-kimlik-subtitle">Logo ve Logo kullanım Kılavuzu</p>
        <a
          href="https://drive.google.com/drive/folders/1OWtBgZo4vLqLkCudX21ut9XZ-0OAg-1T"
          target="_blank"
          rel="noopener noreferrer"
          className="kurumsal-kimlik-button"
        >
          İNDİR
        </a>
      </div>
    </section>
  );
};

export default AboutUsKurumsalKimlik;
